// extracted by mini-css-extract-plugin
export var bounce = "_p1-1";
export var generatingText = "_p1-6";
export var lightning = "_p1-4";
export var popup = "_p1-5";
export var progressBar = "_p1-7";
export var progressFill = "_p1-8";
export var progressShimmer = "_p1-9";
export var progressText = "_p1-a";
export var shimmer = "_p1-3";
export var uploadIcon = "_p1-0";
export var uploadingText = "_p1-2";